<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="arrow" v-if="mode == 'all'">
            <i class="fa fa-arrow-up fa-2x" @click="goToStartSlide"></i>
            <br>
            <i class="fa fa-arrow-down fa-2x" @click="goToEndSlide"></i>
          </div>
          <template  v-if="!mode">
            <b-row>
              <div class="table-responsive">
                <!-- untuk seluruh customer dalam 1 bulan-->
                <template v-if="!typeDataObject">
                  <customer-year :detailDown="detailDownTime" :total="totalDownTime" :average="averaGe"></customer-year>
                </template>
                <template v-else>
                  <!--untuk 1 customer dalam 1 bulan-->
                  <customer-detail :detail="objectDetail"></customer-detail>
                </template>
              </div>
            </b-row>
          </template>
          <template v-else-if="mode == 'all'">
            <b-row >
              <!--untuk bagian semua customer dalam setahun-->
              <customer-year :detailDown="detailDownTime" :total="totalDownTime" :average="averaGe"></customer-year>
            </b-row>
          </template>
          <template v-else-if="mode == 'detail'">
            <b-row>
              <!-- untuk detail hanya bagian catatan customer-->
              <template >
                <detail-total-customer :width="'100%'" :vendor="vendor" :branch="branch" :year="year"></detail-total-customer>
              </template>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>


  </div>
</template>
<script>
  import {getService} from "../../services";
  import CustomerYear from "./detail/CustomerYear"
  import CustomerDetail from './detail/CustomerDetail'
  import DetailTotalCustomer from './DetailTotalCustomer'
  export default {
    components: {
      CustomerYear,
      CustomerDetail,
      DetailTotalCustomer
    },
    data() {
      return {
        detailDownTime: [],
        objectDetail: {},
        typeDataObject: false,
        mode: '',
        totalDownTime: 0,
        averaGe: 0,
        positionTop: true,
        positionDown: false,
        vendor: '',
        year: '',
        branch: ''
      }
    },

    created: function () {
      let id, date, vendor, branch
      id = this.$route.query.id
      date = this.$route.query.date
      vendor = this.$route.query.vendor
      branch = this.$route.query.branch
      this.mode = this.$route.query.mode || ''
      if (this.mode == 'detail') {
        //masi dalam setahun
        this.vendor = vendor
        this.year = date
        this.branch = branch
        // this.getTotalCustomerInVendor(vendor, date, '', branch)
      } else {
        this.getDetailCustomerDown(id, date, vendor, branch)
      }
    },
    methods: {
      getDetailCustomerDown: function (id, date, vendor, branch) {
        this.$store.commit('noLoad', true)
        getService.detail_cutomer_down_by_vendor(id, date, vendor, branch)
          .then(
            data => {
              this.$store.commit('noLoad', false)
              if (data.length) {
                // array
                let indeks = 0
                let total = 0
                this.typeDataObject = false
                this.detailDownTime = data
                for (let i in data) {
                  if (data.hasOwnProperty(i)) {
                    this.totalDownTime += data[i].data_count
                    const detailDown = data[i].data
                    for (let j in detailDown) {
                      if(detailDown.hasOwnProperty(j)) {
                        total += detailDown[j].duration
                        if (detailDown[j].duration) {
                          indeks++
                        }
                      }
                    }
                  }
                }
                this.averaGe = total / indeks
              } else {
                // object
                if (id == 'all') {
                  let dataAllDownTimes = []
                  let dataDownTime
                  let total = 0
                  let indeks = 0
                  for(let i in data) {
                    if (data.hasOwnProperty(i)) {
                      dataDownTime = data[i]
                      for (let j in dataDownTime) {
                        if(dataDownTime.hasOwnProperty(j)) {
                          const detail = dataDownTime[j]
                          dataAllDownTimes.push(detail)
                          this.totalDownTime += detail.data_count
                          for ( let key in detail.data) {
                            if (detail.data.hasOwnProperty(key)) {
                              total += detail.data[key].duration
                              if (detail.data[key].duration) {
                                indeks++
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  this.averaGe = total / indeks
                  this.detailDownTime = dataAllDownTimes
                } else {
                  this.typeDataObject = true
                  if ( data.customer) {
                      let dataVendor = []
                      let detailCustomerinMonth ={}
                      for (let i in data) {
                          if (typeof data[i]  == 'object') {
                              const dataDetail = data[i]
                              for (let j in dataDetail) {
                                if (detailCustomerinMonth.cust_acc_name) {
                                    detailCustomerinMonth.data = dataVendor.concat(dataDetail[j].data)
                                } else {
                                    dataVendor = dataDetail[j].data
                                    detailCustomerinMonth = {
                                        cust_acc_name : dataDetail[j].cust_acc_name,
                                        installation_address: dataDetail[j].installation_address,
                                        cust_activation_date: dataDetail[j].cust_activation_date,
                                        data: dataVendor,
                                    }
                                }
                              }
                          }
                      }
                      this.objectDetail = detailCustomerinMonth
                  } else {
                      this.objectDetail = data
                  }
                }
              }
            }
          )
      },
      sortBy(item) {
        item.sort((a, b) => {
          var nameA = a.cust_acc_name.toLowerCase()
          var nameB = b.cust_acc_name.toLowerCase()
          if (nameA > nameB) {
            return -1
          }
          return 1
        })

      },
      goToEndSlide() {
        let height = document.getElementById('tableAll').offsetHeight
        window.scrollTo({
          top: height,
          behavior: 'smooth'
        });
      },
      goToStartSlide() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }
</script>

<style>
  .arrow{
    position: fixed;
    bottom: 80px;
    right: 20px;
  }
  .arrow>i{
    background-color: #cccccc;
    color:#7f7f7f;
  }

  table.table-all>thead>tr>th{
    vertical-align: middle;
  }
</style>
